exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".custom-alert-edit .form-text{height:30px;padding:0 4px}.custom-alert-edit .form-text,.custom-alert-edit .form-textarea{border-radius:4px;border:1px solid #ccc;color:#333;width:100%;box-sizing:border-box}.custom-alert-edit .form-textarea{padding:4px}.custom-alert-edit .form-submit{margin-right:12px}.custom-alert-edit .modal-footer{display:flex;justify-content:space-between}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/searchAlerts/CustomAlerts/CustomAlertEdit.less
// module id = 1637
// module chunks = 0